import { useDroppable } from "@dnd-kit/core";
import {
  Avatar,
  Divider,
  Flex,
  Popover,
  ScrollAreaAutosize,
} from "@mantine/core";
import dayjs from "dayjs";
import styled from "styled-components";
import { deleteEmployeeFromShiftById } from "../../api/shiftAssignmentApi";
import { createNotification } from "../../utils/useNotification";

const CalendarShiftEvent = ({
  event,
  activeTab,
  setSelectedEvent,
  setIsModalOpen,
  getShiftsForEmployeeAssign,
  selectedRole,
}: any) => {
  const { isOver, setNodeRef } = useDroppable({
    id: event.id.toString(),
  });

  const deleteEmployeeFromShift = async ({ shiftId, employeeId }: any) => {
    try {
      const response: any = await deleteEmployeeFromShiftById({
        shiftId,
        employeeId,
      });
      if (response?.success) {
        getShiftsForEmployeeAssign();
        createNotification({
          success: response?.success,
          message: response?.message,
        });
      } else {
        createNotification({
          success: response?.success,
          message: response?.message,
        });
      }
    } catch (err) {}
  };

  const Event = ({ isCursorDefault }: any) => {
    return (
      <EventWrapper
        $event={event}
        style={{
          backgroundColor: isOver ? "#e0e7ff" : undefined,
          cursor: isCursorDefault && "default",
        }}
      >
        <EventTitle className="event-title">{event?.title}</EventTitle>
        {activeTab === "shift-plan" ? (
          event?.count && <EventCount>{event?.count}</EventCount>
        ) : (
          <AssignCount className="count">
            {event?.employees?.length}/{event.count}
          </AssignCount>
        )}
      </EventWrapper>
    );
  };

  return (
    <>
      <Popover offset={24} width={500} position="left-start" shadow="md">
        <Popover.Target>
          <div
            ref={setNodeRef}
            style={{
              padding:
                setSelectedEvent && setIsModalOpen ? "" : "0px 8px 0px 8px",
              borderRadius: 6,
            }}
          >
            <Event />
          </div>
        </Popover.Target>
        <Popover.Dropdown>
          <Flex gap={16} direction={"column"}>
            <Flex direction={"column"} gap={12}>
              <ModalTitle>
                {dayjs(event.startTime).format("dddd, MMMM DD")}
              </ModalTitle>
              <div>{selectedRole?.label}</div>
              <Event isCursorDefault={true} />
            </Flex>
            <Divider />
            <ScrollAreaAutosize
              h={event?.employees?.length > 5 ? "270px" : "max-content"}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {event?.employees?.map((employee: any) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Flex align={"center"} gap={12}>
                      <Avatar bg={"#EEF2FF"} size="44px">
                        <span>{employee?.name[0]}</span>
                      </Avatar>
                      <div>{employee?.name}</div>
                    </Flex>
                    <DeleteIcon
                      onClick={(e: any) => {
                        deleteEmployeeFromShift({
                          employeeId: employee?.id,
                          shiftId: event?.id,
                        });
                      }}
                    >
                      <Avatar
                        className="icon"
                        radius={0}
                        size={24}
                        src={"/assets/deleteEmployeeIcon.png"}
                      />
                    </DeleteIcon>
                  </div>
                ))}
              </div>
            </ScrollAreaAutosize>
          </Flex>
        </Popover.Dropdown>
      </Popover>
    </>
  );
};

export default CalendarShiftEvent;

const EventWrapper = styled.div<{ $event: any }>`
  display: flex;
  width: 100%;
  align-items: center;
  height: 24px;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 50px;

  background-color: ${({ $event }) =>
    $event?.employees?.length === 0
      ? "#F3F4F6"
      : $event?.employees?.length > 0 &&
        $event.employees?.length < $event?.count
      ? "#FEF3F2"
      : $event?.employees?.length === $event?.count
      ? "#ECFDF3"
      : "#F3F4F6"};

  .count {
    color: ${({ $event }) =>
      $event?.employees?.length === 0
        ? "#111827"
        : $event?.employees?.length > 0 &&
          $event.employees?.length < $event?.count
        ? "#EE4549"
        : $event?.employees?.length === $event?.count
        ? "#10B981"
        : "#F3F4F6"};
  }
  .event-title {
    color: ${({ $event }) =>
      $event?.employees?.length === 0
        ? "#111827"
        : $event?.employees?.length > 0 &&
          $event.employees?.length < $event?.count
        ? "#EE4549"
        : $event?.employees?.length === $event?.count
        ? "#10B981"
        : "#4B5563"};
  }

  &: hover {
    // background: unset;
  }
`;

const EventTitle = styled.span`
  margin-left: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4b5563;
`;

const EventCount = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 50px;
  width: 15%;
  background-color: #eef2ff;
  border: 4px solid white;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #5c26ff;
`;

const AssignCount = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #4b5563;
  padding: 0px 8px;
`;

const ModalTitle = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: #111827;
`;

const DeleteIcon = styled(Flex)<any>`
  cursor: pointer;
  align-items: center;
  padding: 4px;
  height: max-content;
  border-radius: 6px;
  background: none;
  &:hover {
    background: #fef3f2;
    .icon {
      filter: brightness(0) saturate(100%) invert(36%) sepia(19%)
        saturate(4307%) hue-rotate(326deg) brightness(101%) contrast(97%);
    }
  }
`;
